import { css } from '@lastbrand/web-ui-styled-system/css'

export const subscriptionDeliveryMessage = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  backgroundColor: 'paperwhite',
  paddingBlock: 'space-16',
  paddingInline: 'space-12',
  marginBottom: 'space-24',
  gap: 'space-16',
  // Legacy pins a 31.5rem (315px at 10px root) width on mobile.
  lgDown: { width: '315px' },
})

export const subscriptionDeliveryMessage_newDesignV2 = css({
  lgDown: { width: 'full' },
})

export const contentWrapper = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 'space-8',
})

export const iconWrapper = css({
  flexShrink: 0,
  alignSelf: 'flex-start',
  width: 'token(spacing.space-16)',
  height: 'token(spacing.space-16)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const iconImage = css({
  width: 'token(spacing.space-16)',
  height: 'token(spacing.space-16)',
  display: 'block',
  objectFit: 'contain',
  '& img': {
    objectFit: 'contain',
    width: 'full',
    height: 'full',
  },
})

export const text = css({
  textStyle: 'body-14',
})

export const manageSubscriptionLink = css({
  textDecoration: 'underline',
  textUnderlineOffset: 'space-4',
  flexShrink: 0,
  textStyle: 'body-14',
})
